/* Component Dependencies */
var guestRoomDetailsTemplate = require('templates/guestRoomDetails.hbs');
var guestRoomDetailsQuickGroupTemplate = require('templates/guestRoomDetails-quickGroup.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
    type: 'guestRoomDetails',
    template: {
        'guestRoomDetails': guestRoomDetailsTemplate,
        'guestRoomDetails-quickGroup': guestRoomDetailsQuickGroupTemplate
    },
    bindEvents: function() {
        var _self = this;
        _self.$el.find('.tile-label').parent().on('click', _self.toggleRoomDetails);
    },
    subscribe: {
        'GUEST_ROOM_NAVIGATION': 'saveRoomPoolDetails'
    },
    roomPoolState: {},
    /**
     * This function is used to toggle the room details section on click of close/detail label or up/down arrow key
     * @param {Object} event Mouse event triggered on close/detail label or up/down arrow click
     */
    toggleRoomDetails: function(event) {
        var roomDetails, parentContainer, arrowKey, closeDetailLabel, detailsSection;

        roomDetails = $(event.currentTarget).find('.tile-label');
        parentContainer = roomDetails.parent();
        detailsSection = parentContainer.find('.tile-detail-section');
        detailsSection.toggleClass('is-hidden');
        arrowKey = parentContainer.find('.tile-label > span:nth-of-type(2)');
        closeDetailLabel = parentContainer.find('.tile-label > span:nth-of-type(1)');

        if (arrowKey.hasClass('t-icon-arrow-up')) {
            arrowKey.removeClass('t-icon-arrow-up');
            arrowKey.addClass('t-icon-arrow-down');
        } else {
            arrowKey.removeClass('t-icon-arrow-down');
            arrowKey.addClass('t-icon-arrow-up');
        }

        if (detailsSection.hasClass("is-hidden")) {
            closeDetailLabel.text(closeDetailLabel.data('hidden-label'));
            roomDetails.attr('aria-expanded', 'false');
            detailsSection.attr('aria-hidden', 'true');
        } else {
            closeDetailLabel.text(closeDetailLabel.data('visible-label'));
            roomDetails.attr('aria-expanded', 'true');
            detailsSection.attr('aria-hidden', 'false');
        }
    },
    /**
     * This function is used to save the state of previous and next room pool during navigattion
     * @param {Object} event Mouse event triggered on clicking next and previous navigation buttons
     */
    saveRoomPoolDetails: function(context) {
        var componentID = this.$el.attr("data-component-id"),
            currentComponentState, nextState;

        if (!this.roomPoolState[componentID]) {
            currentComponentState = this.roomPoolState[componentID] = {};
        } else {
            currentComponentState = this.roomPoolState[componentID];
        }

        currentState = currentComponentState[context.currentPoolCode] || {};
        currentState.roomOverviewDetails = this.$el.find(".room-overview .tile-detail-section").hasClass("is-hidden");
        currentState.roomAmenitiesDetails = this.$el.find(".room-amenities .tile-detail-section").hasClass("is-hidden");
        currentState.roomMediaDetails = this.$el.find(".room-media .tile-detail-section").hasClass("is-hidden");

        currentComponentState[context.currentPoolCode] = currentState;

        this.refresh(context, function(response) {
            nextState = currentComponentState[response.roomPoolCode];
            if (nextState) {
                if (nextState.roomOverviewDetails) {
                    this.updateRoomPoolState(".room-overview", false);
                }
                if (!nextState.roomAmenitiesDetails) {
                    this.updateRoomPoolState(".room-amenities", true);
                }
                if (!nextState.roomMediaDetails) {
                    this.updateRoomPoolState(".room-media", true);
                }
            }
        }.bind(this));
    },
    /**
     * This function is used to update the inittial state of room pool if any change occurs
     * @param {selector} room area being selected
     * @param {isOpen} boolean value true if change occures false if not
     */
    updateRoomPoolState: function(selector, isOpen) {
        var roomSection = this.$el.find(selector + " .tile-detail-section"),
            drawerButton = this.$el.find(selector + " .tile-label > span:nth-of-type(2)"),
            labelButton = this.$el.find(selector + " .tile-label > span:nth-of-type(1)");
        if (isOpen) {
            roomSection.removeClass("is-hidden");
            drawerButton.addClass("t-icon-arrow-up").removeClass("t-icon-arrow-down");
            labelButton.text((labelButton).data('visible-label'));
        } else {
            roomSection.addClass("is-hidden");
            drawerButton.removeClass("t-icon-arrow-up").addClass("t-icon-arrow-down");
            labelButton.text((labelButton).data('hidden-label'));
        }
    }
});
